import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tabelapreco.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionMover = ({dispatch},payload)=>{
    return serves.tabelapreco.mover(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.tabelapreco.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.tabelapreco.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',err)
    })
}
export const ActionPadrao = ({dispatch},payload)=>{
    return serves.tabelapreco.padrao(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',err)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.tabelapreco.delete(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.tabelapreco.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionDuplica = ({dispatch},payload)=>{
    return serves.tabelapreco.duplica(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.tabelapreco.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionConfiguracaoCartaoPonto = ({dispatch},payload)=>{
    return serves.tabelapreco.configuracaocartaoponto(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionMatricula = ({dispatch},payload)=>{
    return serves.tabelapreco.matricula(payload).then(res => {
        dispatch('ActionSetMatricula',res)
    }).catch(err => {
        dispatch('ActionSetMatricula',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetMatricula = ({commit},payload) =>{
    commit(types.SET_MATRICULA,payload)
}
